import vocabulariesApi from './api';
import vocabulariesToasts from './toasts';

export default [
  vocabulariesApi(),
  vocabulariesToasts(),
];
